import styles from './BlockArrow.module.css'

interface BlockArrowProps {
  direction: "left" | "right"
  onClick: () => void
}

export default function BlockArrow(props: BlockArrowProps) {
  if (props.direction === "left") {
    return <div className={[styles.blockArrow, styles.blockArrowLeft].join(' ')} onClick={props.onClick}>
      <div className={styles.arrowLeft}></div>
    </div>
  } else {
    return <div className={[styles.blockArrow, styles.blockArrowRight].join(' ')} onClick={props.onClick}>
      <div className={styles.arrowRight}></div>
    </div>
  }
}